import { buildModelManager } from "../builder.js";
const DefaultInvoiceSelection = {
  __typename: true,
  id: true,
  clientId: true,
  createdAt: true,
  deletedAt: true,
  dueDate: true,
  externalIds: true,
  invoiceNumber: true,
  issuedDate: true,
  jobId: true,
  lastReminderSentAt: true,
  notes: true,
  paidAt: true,
  paymentMethod: true,
  paymentTerms: true,
  profileId: true,
  status: true,
  subtotal: true,
  syncIdempotencyKey: true,
  syncStatus: true,
  total: true,
  updatedAt: true,
  vatTotal: true,
  viewedAt: true,
  workItemId: true
};
const modelApiIdentifier = "invoice";
const pluralModelApiIdentifier = "invoices";
;
;
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByInvoiceNumber",
    findByField: "invoiceNumber",
    findByVariableName: "invoiceNumber",
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByInvoiceNumber",
    findByField: "invoiceNumber",
    findByVariableName: "invoiceNumber",
    modelApiIdentifier,
    defaultSelection: DefaultInvoiceSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createInvoice",
    operationReturnType: "CreateInvoice",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { invoice: { required: false, type: "CreateInvoiceInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkCreateInvoices",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateInvoicesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "updateInvoice",
    operationReturnType: "UpdateInvoice",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      invoice: { required: false, type: "UpdateInvoiceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateInvoices",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateInvoicesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "deleteInvoice",
    operationReturnType: "DeleteInvoice",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteInvoices",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "markPaidInvoice",
    operationReturnType: "MarkPaidInvoice",
    functionName: "markPaid",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      invoice: { required: false, type: "MarkPaidInvoiceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkMarkPaidInvoices",
    functionName: "bulkMarkPaid",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "markPaid",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkMarkPaidInvoicesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "restoreInvoice",
    operationReturnType: "RestoreInvoice",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      invoice: { required: false, type: "RestoreInvoiceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreInvoices",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkRestoreInvoicesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "sendInvoice",
    operationReturnType: "SendInvoice",
    functionName: "send",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      invoice: { required: false, type: "SendInvoiceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkSendInvoices",
    functionName: "bulkSend",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "send",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkSendInvoicesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "updateRemindersInvoice",
    operationReturnType: "UpdateRemindersInvoice",
    functionName: "updateReminders",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      invoice: { required: false, type: "UpdateRemindersInvoiceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateRemindersInvoices",
    functionName: "bulkUpdateReminders",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "updateReminders",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateRemindersInvoicesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "upsertInvoice",
    operationReturnType: "UpsertInvoice",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      invoice: { required: false, type: "UpsertInvoiceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateInvoiceResult": { hasReturnType: false },
      "... on UpdateInvoiceResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertInvoices",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertInvoicesInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultInvoiceSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "invoiceGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const InvoiceManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultInvoiceSelection,
  operations
);
export {
  DefaultInvoiceSelection,
  InvoiceManager
};
//# sourceMappingURL=Invoice.js.map
